import type { MouseEvent, ReactNode, TdHTMLAttributes, ThHTMLAttributes } from 'react';

type CellProps = TdHTMLAttributes<HTMLTableCellElement> & ThHTMLAttributes<HTMLTableCellElement>;

export interface CheckCellProps extends CellProps {
  /** A header cell for the select-all box; a body cell otherwise. */
  as?: 'td' | 'th';
  children: ReactNode;
}

/**
 * A table cell whose whole area ticks the box inside it. A picker aims at the row, not at a 13px square,
 * so the cell is the hit area; the box's own click already toggles it, and a link, button or label inside
 * the cell stays its own control.
 */
export function CheckCell({ as: Tag = 'td', children, onClick, className, style, ...rest }: CheckCellProps) {
  const tick = (event: MouseEvent<HTMLTableCellElement>) => {
    onClick?.(event);
    const box = event.currentTarget.querySelector<HTMLInputElement>('input[type="checkbox"]');
    const target = event.target as HTMLElement;
    if (!box || box.disabled || target === box || target.closest('a, button, label, input')) {
      return;
    }
    box.click();
  };
  return (
    <Tag
      className={['chk-cell', className].filter(Boolean).join(' ')}
      style={{ cursor: 'pointer', ...style }}
      onClick={tick}
      {...rest}
    >
      {children}
    </Tag>
  );
}
